import styled from '@emotion/styled';
import rem from '../../../../utils/rem/rem';

export const ProgressContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`;

export const StatusRow = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem(12)};
  font-family: 'Open Sans';
  font-size: ${rem(16)};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.gray900};
`;

export const ProgressTrack = styled.div`
  width: 100%;
  height: ${rem(8)};
  border-radius: ${rem(4)};
  background-color: ${({ theme }) => theme.colors.gray200};
  overflow: hidden;
`;

export const ProgressFill = styled.div`
  height: 100%;
  background-color: ${({ theme }) => theme.colors.red};
  border-radius: ${rem(4)};
  transition: width 0.3s ease-in-out;
`;

export const MenuCount = styled.p`
  font-family: 'Open Sans';
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.gray600};
  margin: 0;
`;

export const KeepOpenHint = styled.p`
  font-family: 'Open Sans';
  font-size: ${rem(12)};
  color: ${({ theme }) => theme.colors.gray600};
  margin: 0;
`;
